<template>
    <div>
        <drawer-pad
            :algorithms="algorithms"
            :directions="directions"
            :index="currentSurface">
        </drawer-pad>
        <surface-list :editable="true" @current="currentSurface = $event"/>
        <v-btn color="primary" :disabled="!valid" @click="$emit('complete')">{{ $t('base.next') }}</v-btn>
    </div>
</template>

<script>
    import DrawerPad from '@/components/workspace/Drawer'
    import SurfaceList from "@/components/workspace/SurfaceList";

    export default {
        components: {SurfaceList, DrawerPad},
        data() {
            return {
                error: false,
                errorMessage: '',
                loading: false,
                currentSurface: 0,
            }
        },
        computed: {
            surfaces() {
                return this.$store.state.configurator.surfaces
            },
            valid() {
                let invalid = this.surfaces.filter(surface => !surface.valid)
                return invalid.length === 0
            },
            algorithms() {
                return [{
                    value: 'frugal',
                    label: this.$t('steps.materials.algorithms.frugal')
                }, {
                    value: 'expanding',
                    label: this.$t('steps.materials.algorithms.expanding')
                }];
            },
            directions() {
                return [{
                    value: 'west',
                    label: this.$t('directions.west'),
                    icon: 'mdi-arrow-right',
                    horizontal: false
                }, {
                    value: 'east',
                    label: this.$t('directions.east'),
                    icon: 'mdi-arrow-left',
                    horizontal: false
                }, {
                    value: 'north',
                    label: this.$t('directions.north'),
                    icon: 'mdi-arrow-down',
                    horizontal: true
                }, {
                    value: 'south',
                    label: this.$t('directions.south'),
                    icon: 'mdi-arrow-up',
                    horizontal: true
                }]
            }
        },
    }
</script>

<style scoped>
</style>
